import { formatPorcionesOCantidad, parseFechaLocal } from '../utils/pedidoDisplay';

const DECORACION_LABELS = {
  ninguno: null,
  nina: "Niña",
  nino: "Niño",
  mujer: "Mujer",
  hombre: "Hombre",
};

const CATEGORIA_LABELS = {
  queque: "Queque",
  tarta: "Tartas y Cheesecakes",
  empanada: "Empanadas",
  coctel: "Dulces de Cóctel",
  mousse: "Mousse",
};

const TIPOS_VENTA_TORTA = ["torta_configurable", "precio_manual"];

function resolverEtiquetaProducto(pedido) {
  const tipoVenta = pedido.tipo_venta || "torta_configurable";
  if (TIPOS_VENTA_TORTA.includes(tipoVenta)) {
    return "Torta";
  }
  const categoria = (pedido.categoria || "").toLowerCase().trim();
  if (CATEGORIA_LABELS[categoria]) {
    return CATEGORIA_LABELS[categoria];
  }
  if (categoria) {
    return categoria.charAt(0).toUpperCase() + categoria.slice(1);
  }
  return pedido.producto || "Producto";
}

function formatearPersonalizaciones(personalizaciones) {
  if (!Array.isArray(personalizaciones) || personalizaciones.length === 0) return null;
  return personalizaciones
    .filter((p) => p && (p.nombre || p.id))
    .map((p) => p.nombre || `Personalización #${p.id}`)
    .join(', ');
}

function construirItemsHtml(lista, mostrarPrecios) {
  return lista.map((pedido, idx) => {
    const etiqueta = resolverEtiquetaProducto(pedido);
    const decor = DECORACION_LABELS[pedido.decoracion];
    const personalizacion = formatearPersonalizaciones(pedido.personalizaciones);

    let lineaProducto = '';
    if (lista.length > 1) {
      lineaProducto = `<b>${etiqueta} ${idx + 1}: </b>`;
    }

    let html = `
      <div style="padding: 8px 0; margin: 8px 0; ${idx > 0 ? 'border-top: 1px dashed #999;' : ''}">
        <p style="margin:4px 0; font-size: 16px;">${lineaProducto}<b>${pedido.producto}</b></p>`;

    if (pedido.sabor) {
      html += `<p style="margin:4px 0; font-size: 15px;">Sabor: ${pedido.sabor}</p>`;
    }

    if (pedido.porcion != null) {
      html += `<p style="margin:4px 0; font-size: 15px;">Porciones: ${pedido.porcion} — ${pedido.formato === 'cuadrada' ? 'Cuadrada' : 'Redonda'}</p>`;
    } else {
      const qty = pedido.cantidad ?? 1;
      const pkg = pedido.cantidad_paquete;
      if (pkg) {
        const totalUds = qty * pkg;
        html += `<p style="margin:4px 0; font-size: 15px;">Paquete: ${pkg} unidades</p>`;
        html += `<p style="margin:4px 0; font-size: 15px;">Cantidad de paquetes: ${qty}</p>`;
        html += `<p style="margin:4px 0; font-size: 15px;">Total de unidades: ${totalUds}</p>`;
        if (mostrarPrecios) {
          html += `<p style="margin:4px 0; font-size: 15px;">Precio por paquete: $${parseInt(pedido.precio_unitario || 0).toLocaleString('es-CL')}</p>`;
          html += `<p style="margin:4px 0; font-size: 15px;">Subtotal: $${parseInt(pedido.precio_total).toLocaleString('es-CL')}</p>`;
        }
      } else {
        html += `<p style="margin:4px 0; font-size: 15px;">Cantidad: ${formatPorcionesOCantidad(pedido)}</p>`;
      }
    }

    if (pedido.detalle_especial) {
      html += `<p style="margin:4px 0; font-size: 15px;">Detalle: ${pedido.detalle_especial}</p>`;
    }

    if (decor) {
      html += `<p style="margin:4px 0; font-size: 15px;">Decoración: ${decor}</p>`;
    }

    if (personalizacion) {
      html += `<p style="margin:4px 0; font-size: 15px;">Personalización: ${personalizacion}</p>`;
    }

    if (Array.isArray(pedido.variedades) && pedido.variedades.length > 0) {
      html += `<p style="margin:4px 0; font-size: 15px;">Variedades: ${pedido.variedades.join(', ')}</p>`;
    }

    if (pedido.mensaje_torta) {
      html += `<p style="margin:4px 0; font-size: 15px;">Mensaje: "${pedido.mensaje_torta}"</p>`;
    }

    if (mostrarPrecios) {
      html += `<p style="margin:4px 0; font-size: 15px;">Precio: $${parseInt(pedido.precio_total).toLocaleString('es-CL')}</p>`;
    }

    html += `</div>`;
    return html;
  }).join('');
}

function construirHtmlCompleto(lista, mostrarPrecios, opciones) {
  const primero = lista[0];
  const itemsHtml = construirItemsHtml(lista, mostrarPrecios);

  const totalGeneral = lista.reduce((sum, p) => sum + parseInt(p.precio_total || 0), 0);
  const abonoGeneral = lista.reduce((sum, p) => sum + parseInt(p.abono || 0), 0);
  const saldoGeneral = lista.reduce((sum, p) => sum + parseInt(p.saldo || 0), 0);

  const titulo = mostrarPrecios
    ? ''
    : `<div style="text-align: center; background: #000; color: #fff; padding: 8px; margin-bottom: 8px;">
        <p style="margin:0; font-size: 20px; font-weight: bold;">ORDEN DE PRODUCCIÓN</p>
      </div>`;

  let headerInfo = `
    <div style="border-top: 2px dashed #000; border-bottom: 2px dashed #000; padding: 8px 0; margin: 8px 0;">
      <p style="margin:4px 0; font-size: 16px;"><b>Pedido:</b> ${primero.numero_pedido}${lista.length > 1 ? ` - ${lista.length} items` : ''}</p>
      <p style="margin:4px 0; font-size: 16px;"><b>Cliente:</b> ${primero.cliente_nombre}</p>
      <p style="margin:4px 0; font-size: 16px;"><b>Teléfono:</b> ${primero.cliente_telefono}</p>`;

  if (!mostrarPrecios) {
    const fechaEntrega = parseFechaLocal(primero.fecha_entrega);
    const fechaEntregaStr = fechaEntrega
      ? fechaEntrega.toLocaleDateString('es-CL', {day:'numeric', month:'long'})
      : 'Sin fecha';
    headerInfo += `
      <p style="margin:4px 0; font-size: 20px; font-weight: bold; color: red;">
        ENTREGA: ${fechaEntregaStr} · ${primero.hora_entrega?.slice(0,5)} hrs
      </p>`;
  }

  headerInfo += `</div>`;

  const fechaEntrega = parseFechaLocal(primero.fecha_entrega);
  const fechaEntregaStr = fechaEntrega
    ? fechaEntrega.toLocaleDateString('es-CL', {day:'numeric', month:'long', year:'numeric'})
    : 'Sin fecha';
  let entregaLocal = `
    <div style="border-top: 2px dashed #000; padding: 8px 0; margin: 8px 0;">
      <p style="margin:4px 0; font-size: 16px;"><b>Entrega:</b> ${fechaEntregaStr} a las ${primero.hora_entrega?.slice(0,5)}</p>`;

  if (primero.local_origen) {
    entregaLocal += `<p style="margin:4px 0; font-size: 16px;"><b>Local:</b> ${primero.local_origen.toUpperCase()}</p>`;
  }

  entregaLocal += `</div>`;

  let footer = '';
  if (mostrarPrecios) {
    footer = `
      <div style="border-top: 2px dashed #000; padding: 8px 0; margin: 8px 0;">
        <p style="margin:4px 0; font-size: 18px;"><b>Total: $${totalGeneral.toLocaleString('es-CL')}</b></p>
        <p style="margin:4px 0; font-size: 16px;">Abono: $${abonoGeneral.toLocaleString('es-CL')}</p>
        <p style="margin:4px 0; font-size: 18px; color: ${saldoGeneral > 0 ? 'red' : 'green'};">
          <b>Saldo: $${saldoGeneral.toLocaleString('es-CL')}</b>
        </p>
      </div>
      <div style="text-align: center; margin-top: 10px; font-size: 16px; border-top: 2px dashed #000; padding-top: 15px;">
        <p style="margin:8px 0;"><b>¡Gracias por su preferencia!</b></p>
        <p style="margin:15px 0;">&nbsp;</p>
        <p style="margin:15px 0;">&nbsp;</p>
        <p style="margin:15px 0;">&nbsp;</p>
      </div>`;
  } else {
    footer = `
      <div style="text-align: center; margin-top: 10px; font-size: 14px; border-top: 2px dashed #000; padding-top: 10px;">
        <p style="margin:15px 0;">&nbsp;</p>
        <p style="margin:15px 0;">&nbsp;</p>
      </div>`;
  }

  const logoHtml = mostrarPrecios
    ? `<div style="text-align: center; margin-bottom: -60px; margin-top: 0px;">
        <img src="${window.location.origin}/logobancher.png" style="width:200px; height:200px; object-fit:contain; display:block; margin:0 auto;" />
      </div>`
    : '';

  return `
    <div style="font-family: monospace; width: 280px; padding: 2px 10px 10px 10px; page-break-inside: avoid;">
      ${logoHtml}
      ${titulo}
      ${headerInfo}
      ${itemsHtml}
      ${entregaLocal}
      ${footer}
    </div>`;
}

function abrirVentanaImpresion(htmlContenido) {
  const ventana = window.open('', '_blank', 'width=400,height=800');
  if (!ventana) {
    alert('Permita ventanas emergentes para imprimir');
    return;
  }

  ventana.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>Comprobante</title>
  <style>
    @media print {
      @page { margin: 0; }
      .page-break { break-after: page; page-break-after: always; }
      .ticket { width: 54mm; page-break-inside: avoid; }
    }
    body { font-family: monospace; margin: 0; padding: 0; }
    .ticket { width: 54mm; word-wrap: break-word; }
    div { width: 54mm !important; word-wrap: break-word; }
  </style>
</head>
<body>
  ${htmlContenido}
</body>
</html>`);
  ventana.document.close();
  ventana.onload = () => {
    ventana.focus();
    ventana.print();
  };
}

export function imprimirComprobante(pedidos) {
  const lista = Array.isArray(pedidos) ? pedidos : [pedidos];

  const clienteHtml = construirHtmlCompleto(lista, true);
  const produccionHtml = construirHtmlCompleto(lista, false);

  const htmlCombinado = `${clienteHtml}<div class="page-break"></div>${produccionHtml}`;

  abrirVentanaImpresion(htmlCombinado);
}

function imprimirOrdenProduccion(lista) {
  const ordenProduccion = construirHtmlCompleto(lista, false);
  abrirVentanaImpresion(ordenProduccion);
}

export { imprimirOrdenProduccion };
